export enum IMAGE_RESOLUTIONS {
  HD = 'HD',
  '4K' = '4K',
  '8K' = '8K',
}

export enum EXPORT_OPTIONS {
  PDF = 'pdf',
  PNG = 'png',
}
